<template>
  <div>
    <!-- Header -->
    <div class="header bg-home py-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">

          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <section id="intro-content">
      <div class="container intro">
        <div class="py-4">
          <h2 class="display-3">Perfil Empreendedor<span class="text-secondary">Conheça o seu</span></h2>
          <p class="lead">Por existir ainda muita especulação e “mitos” relacionados à vida
            empreendedora, desenvolvi o <b class="text-secondary">Teste de Perfil Empreendedor</b> com o
            objetivo de ajudar você a descobrir o quanto está próximo de
            ser um empreendedor promissor.
            <br />
            <br />
            São <b class="text-secondary">15 afirmações</b> que envolvem habilidades gerais dos
            empreendedores, como <b class="text-secondary">comportamentos pessoais que o
              empreendedor deve possuir, como age diante dos problemas, a
              capacidade de assumir riscos e seu espírito questionador</b>. Nas
            perguntas, você só precisa marcar a sua resposta. Assim, você irá
            somando pontos e, ao final, descobrirá qual o seu perfil, suas
            potencialidade e o que precisa aperfeiçoar para se tornar um
            empreendedor ainda mais bem preparado e capacitado.
          </p>
        </div>

        <div class="btn-header pt-2">
          <base-button outline type="secondary" class="back-btn" @click="prevPage()">Voltar</base-button>
          <base-button class="my-2" type="secondary">
            <router-link to="/benchmark" >Fazer o Teste</router-link>
          </base-button>
        </div>
      </div>
    </section>
    <!-- Page content -->


  </div>
</template>
<script>
export default {
  name: 'intro',
  data() {
    return {

    }
  },
  methods: {
    prevPage () {
      this.$router.push('home')
    },
  }
};
</script>
<style></style>
